export default {
    list: {
        orderId: 'Номер заказа',
        pfm: 'Код магазина ПФМ',
        dateCreate: 'Дата создания',
        orderStatus: 'Статус обработки',
        deliveryServiceType: 'Тип доставки',
        payType: 'Тип оплаты',
        orderSourceType: 'Источник заказа',
        userAuthorization: 'Статус пользователя',
        name: 'ФИО',
        email: 'Почта',
        accuracy: 'Точность заказа',
        orderInfo: 'Информация по заказу',
        integrity: 'Целостность заказа',
        equipment: 'Комплектация заказа',
        comment: 'Комментарий',
        rating: 'Оценка',
    },
    filter: {
        deliveryServiceTypes: {
            placeholder: 'Тип доставки',
            text: 'Выбрано типов доставки',
        },
        payTypes: {
            placeholder: 'Тип оплаты',
            text: 'Выбрано типов оплаты',
        },
        orderSourceTypes: {
            placeholder: 'Источник заказа',
            text: 'Выбрано источников заказа',
        },
        userAuthorization: {
            placeholder: 'Статус пользователя',
            text: 'Выбрано статусов пользователя',
        },
        rating: {
            placeholder: 'Оценка',
            text: 'Выбрано оценок',
        },
        dateCreateFrom: 'Дата создания: от',
        dateCreateTo: 'Дата создания: до',
        orderId: 'Номер заказа',
        pfm: 'Код магазина ПФМ',
        language: 'Язык',
    },
    catalog: {
        'boolean': {
            yes: 'Да',
            no: 'Нет',
        },
    },
    questions: {
        pickUp: {
            text: 'Вопрос для самовывоза',
            accuracy: 'Сотрудники магазина собрали заказ в течение 15 минут?',
            orderInfo: 'Приходило ли Вам смс о готовности заказа?',
            integrity: 'Соответствует ли состояние товаров Вашим ожиданиям?',
            equipment: 'Заказ был скомплектован правильно?',
            rating: 'Как прошел Ваш последний заказ?',
        },
        delivery: {
            text: 'Вопрос для доставки',
            accuracy: 'Вы получили заказ в выбранную дату?',
            orderInfo: 'Вам пришло смс c информацией о заказе?',
            integrity: 'Соответствует ли состояние товаров Вашим ожиданиям?',
            equipment: 'Заказ был скомплектован правильно?',
            rating: 'Как прошел Ваш последний заказ?',
        },
    },
};